import * as React from "react";

import { MultiSelectProps } from "@/components/shared/multi-select/multi-select";
import RemoteMultiselect from "@/components/shared/multi-select/remote-multi-select";
import useDistrictsAutocomplete from "@/hooks/data/use-districts-autocomplete";

interface DistrictSelectProps<T = string>
  extends Omit<MultiSelectProps<T>, "options" | "title"> {
  title?: string;
  state?: string | null;
}

function getUseDistrictsAutocompleteWithStates(states?: string[] | null) {
  return (districts?: string[] | null, search?: string | null) => {
    return useDistrictsAutocomplete(districts, search, states);
  };
}

export default function DistrictSelect({
  value,
  onChange,
  title,
  state,
  ...props
}: DistrictSelectProps) {
  return (
    <RemoteMultiselect
      value={value}
      onChange={onChange}
      title={title || "Districts"}
      useAutocomplete={getUseDistrictsAutocompleteWithStates(
        state ? [state] : null,
      )}
      {...props}
    />
  );
}
